import {
  GET_USER
} from 'src/store/mutation-types'

export default {
  [GET_USER] (state, user) {
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./src/components/user/store/mutations.js